import { Modal } from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Setter } from "./utils/ReactUtils";
import { LinkType, LocationContext } from "./contexts/LinkContext";


export function LocationAgent() {
    const navigate = useNavigate();
    const location = useLocation();
    const { link, setLink } = useContext(LocationContext) as LinkType

    useEffect(() => {

        const label = linkLabels.get(location.pathname)
        label ? setLink(label) : setLink(null)
        
        

        const handleHistoryChange = () => {};
        window.addEventListener('popstate', handleHistoryChange);

        return () => {
            window.removeEventListener('popstate', handleHistoryChange);
        };
    }, [location.pathname]); 

    return (
        <></>
    );
}

const linkLabels = new Map([
    ["/focus", null],
    ["/rules", "Zasady" ],
    ["/character", "Postać"],
    ["/fight", "Walka"],
    ["/shop", "Sklep"],
    ["/magic", "Magia"],
    ["/bestiary", "Bestiariusz" ],
]);